import { render, staticRenderFns } from "./operateaWrap.vue?vue&type=template&id=6147349c&scoped=true&"
import script from "./operateaWrap.vue?vue&type=script&lang=js&"
export * from "./operateaWrap.vue?vue&type=script&lang=js&"
import style0 from "./operateaWrap.vue?vue&type=style&index=0&id=6147349c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147349c",
  null
  
)

export default component.exports